import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import OrderStreamQueueColumn from './live_order_stream_queue_column.jsx';
import {observer, inject} from 'mobx-react';


function calculateFontSizeForWidget(isVertical){
    if(isVertical) {
        return '.5vh'
    }
    return '1vh'
}

@inject('RootStore')
@observer
export default class LiveOrderStreamWidget extends Component {
    render() {
        let columns = [];
        let liveOrderStreamWidget = {
            height:"97%",
            width:"100%",
            fontSize: calculateFontSizeForWidget(this.props.RootStore.configStore.isVertical)
        };

        for(let i=0; i < this.props.RootStore.orderStore.columnCount; i++) {
            columns.push(<OrderStreamQueueColumn colIndex={i} key={i}/>);
            columns.push(<Flexbox key={i + this.props.RootStore.orderStore.columnCount + 2} width='.1%'></Flexbox>);
        }
        return (
            <Flexbox style={liveOrderStreamWidget} flexGrow={1} flexDirection="row">
                <Flexbox width="6.5%"></Flexbox>
                {columns}
                <Flexbox width="6.5%"></Flexbox>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/order_stream_widget/live_order_stream_widget.jsx